/**
 * Created by Robin on 17/12/2022.
 */

import React from 'react';

const APIContext = React.createContext({});
APIContext.displayName = 'APIContext';

export default APIContext;